import { FormItem } from '@/components';
import { pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  gap: 1.5rem;
  width: 100%;

  & > .ant-form-item {
    width: 100%;

    .ant-picker {
      width: 100%;
    }
  }
`;

export const StyledFormItem = styled(FormItem)`
  label {
    ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')}
  }
`;
